const parseDomainAndSubdomain = (hostname: any): any => {
  const parts = hostname.split('.');
  if (parts.length === 1) {
    return {domain: parts[0], subdomain: null};
  } else if (parts.length === 2) {
    return {domain: hostname, subdomain: null};
  } else {
    const domain = parts.slice(-2).join('.');
    const subdomain = parts.slice(0, -2).join('.');
    return {domain, subdomain};
  }
};

const {hostname, port} = window.location;
const {domain = 'localhost', subdomain} = parseDomainAndSubdomain(hostname);

const AppConfig = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TENANT_ID: subdomain || process.env.REACT_APP_TENANT_ID,
  APP_SUBDOMAIN: subdomain,
  APP_DOMAIN: domain,
  APP_PORT: port,
  DESKTOP_APP: process.env.REACT_APP_DESKTOP_APP,
  DEFAULT_APP_NAME: process.env.REACT_APP_DEFAULT_APP_NAME,
  BROWSER_CACHE_ENABLE: process.env.REACT_APP_BROWSER_CACHE_ENABLE === 'true',
  APP_PROFILE: process.env.REACT_APP_APP_PROFILE || 'test',
};

export default AppConfig;
